import { Box, Button, Tooltip } from '@mui/material';
import SelectDeselectProPdfDownloadActionGroup from './select-deselect-pro-pdf-button-group/select-deselect-pro-pdf-button-group';

interface MyFleetProPdfDownloadButtonGroupProps {
  showActionButtons: boolean;
  onShowActions: () => void;
  onCancel: () => void;
  onClick: () => void;
  statusIcon: React.ReactNode;
  statusText: string;
  tooltipContent: React.ReactNode;
  disableDownload: boolean;
}

function MyFleetProPdfDownloadButtonGroup({
  showActionButtons,
  onShowActions,
  onCancel,
  onClick,
  statusIcon,
  statusText,
  tooltipContent,
  disableDownload,
}: MyFleetProPdfDownloadButtonGroupProps) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        minWidth: '48%',
      }}
    >
      {showActionButtons ? (
        <SelectDeselectProPdfDownloadActionGroup
          onCancel={onCancel}
          onClick={onClick}
          statusIcon={statusIcon}
          statusText={statusText}
          tooltipContent={tooltipContent}
          disabled={disableDownload}
        />
      ) : (
        <Tooltip title="Select a vessel to download a PRO report on.">
          <Button
            type="button"
            onClick={onShowActions}
            sx={{ width: '100%' }}
            data-testid="delete-group-button"
          >
            Select PRO Report
          </Button>
        </Tooltip>
      )}
    </Box>
  );
}

export default MyFleetProPdfDownloadButtonGroup;
